module.exports = __webpack_public_path__ + "static/media/fishing-icon.ad9d8e66.svg";